import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { I18nService } from 'app/core/i18n.service';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import { UserService } from 'app/core/user/user.service';
import { ModalService } from 'app/modal/modal.service';
import * as Models from 'app/core/models';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  searchQuery = '';

  constructor(private router: Router,
    private actRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private i18nService: I18nService,
    private userService: UserService,
    private modalService: ModalService) { }

  ngOnInit() {
    const currentUrl = this.router.url;
    if (currentUrl.startsWith('/process/search/')) {
      if (this.actRoute.snapshot.firstChild.paramMap.keys.indexOf('searchQuery') > -1) {
        const searchQuery = this.actRoute.snapshot.firstChild.paramMap.get('searchQuery');
        if (searchQuery) {
          this.searchQuery = searchQuery;
        }
      }
    }
  }

  logout() {
    this.authenticationService.logout()
      .subscribe(() => this.router.navigate(['/home'], { replaceUrl: true }));
  }

  goToMyProcesses() {
    this.router.navigate(['/process/processCategories/', Models.ProcessGroups.EditingAndExecuting]);
  }

  get userFullName(): string {
    return this.userService.userFullName;
  }

  get userEmail(): string {
    return this.userService.userEmail;
  }

  get isAuthenticated(): boolean {
    return this.authenticationService.isAuthenticated();
  }

  login() {
    const data: Models.ModalContext = {
      modalType: Models.ModalType.LOGIN,
      modalAction: Models.ModalAction.OPEN,
      parameters: []
    };
    this.modalService.command(data);
  }

  signup() {
    const data: Models.ModalContext = {
      modalType: Models.ModalType.SIGN_UP,
      modalAction: Models.ModalAction.OPEN,
      parameters: []
    };
    this.modalService.command(data);
  }

  createNewProcess() {
    this.router.navigate(['process/editing/create'], { replaceUrl: true });
  }

  search(): void {
    if (this.searchQuery.trim()) {
      this.router.navigate(['/process/search/', this.searchQuery.trim()]);
    }
  }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/layout/header/header.component.ts